import { useState } from "react";
import CIcon from "@coreui/icons-react";
import {
  CModal,
  CModalHeader,
  CCol,
  CButton,
  CModalBody,
  CButtonGroup,
} from "@coreui/react";
import PulseLoader from "react-spinners/PulseLoader";
import { downloadAnalyticPredictionsCsv } from "../services/DatasetServices";
import PropTypes from "prop-types";

const RawPredictionsModal = ({
  analyticId,
  onReadyToRunChange,
  isRawPredictionsModalVisible,
  setIsRawPredictionsModalVisible,
}) => {
  const [rawCsvDownloading, setRawCsvDownloading] = useState(false);
  return (
    <CModal
      show={isRawPredictionsModalVisible}
      onClose={() => {
        onReadyToRunChange(false);
        setIsRawPredictionsModalVisible(false);
      }}
      style={{ textAlign: "left" }}
    >
      <CModalHeader>
        <CCol sm="11">
          <h4>Raw Predictions CSV Export</h4>
        </CCol>
        <CCol sm="1" style={{ textAlign: "right" }}>
          <CButton
            id="help-close-button"
            color="secondary"
            data-attr="datasets:btn:close-raw-predictions-modal"
            onClick={() => {
              onReadyToRunChange(false);
              setIsRawPredictionsModalVisible(false);
            }}
            size="sm"
          >
            <CIcon name="cil-x" />
          </CButton>
        </CCol>
      </CModalHeader>
      <CModalBody>
        {rawCsvDownloading ? (
          <PulseLoader
            style={{ textAlign: "center" }}
            size={15}
            color={"#9EA59D"}
            loading={rawCsvDownloading}
          />
        ) : (
          <div>
            <div style={{ float: "left", paddingTop: "4px" }}>
              <h5>Include input data fields in csv export?</h5>
            </div>
            <div style={{ float: "left", marginLeft: "10px" }}>
              <CButtonGroup>
                <CButton
                  color="success"
                  data-attr="datasets:btn:export-raw-predictions-with-input"
                  onClick={() => {
                    setRawCsvDownloading(true);
                    downloadAnalyticPredictionsCsv(analyticId, true, () => {
                      setRawCsvDownloading(false);
                      onReadyToRunChange(false);
                      setIsRawPredictionsModalVisible(false);
                    });
                  }}
                >
                  Yes
                </CButton>
                <CButton
                  color="danger"
                  data-attr="datasets:btn:export-raw-predictions-without-input"
                  onClick={() => {
                    setRawCsvDownloading(true);
                    downloadAnalyticPredictionsCsv(analyticId, false, () => {
                      setRawCsvDownloading(false);
                      onReadyToRunChange(false);
                      setIsRawPredictionsModalVisible(false);
                    });
                  }}
                >
                  No
                </CButton>
              </CButtonGroup>
            </div>
          </div>
        )}
      </CModalBody>
    </CModal>
  );
};

RawPredictionsModal.propTypes = {
  analyticId: PropTypes.string.isRequired,
  onReadyToRunChange: PropTypes.func.isRequired,
  isRawPredictionsModalVisible: PropTypes.bool.isRequired,
  setIsRawPredictionsModalVisible: PropTypes.func.isRequired,
};

export default RawPredictionsModal;
